export default __webpack_public_path__ + "static/damixa-commercial-bg@1x-f7439c6195f144f2f28df6b9325842fd.jpg";